import { render, staticRenderFns } from "./Xtest.vue?vue&type=template&id=8a20489a&scoped=true"
import script from "./Xtest.vue?vue&type=script&lang=js"
export * from "./Xtest.vue?vue&type=script&lang=js"
import style0 from "./Xtest.vue?vue&type=style&index=0&id=8a20489a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a20489a",
  null
  
)

export default component.exports